(function(angular, $, _) {
    'use strict';

    angular.module('wtUi').directive('inputNumber', inputNumber);
    inputNumber.$inject = [];

    /**
     * Directive to enable validation on input fields with numbers
     * For floating numbers it is advised to use input[text] because of different types of separators per language setting
     * @return {{restrict: string, require: string, link: link}}
     */
    function inputNumber() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                /**
                 * possible input options: positiveInteger, integer and allowEmpty, noSpecialChar
                 */
                const inputOptions = _.reduce(attrs.inputNumber.split('|'), function(result, key) {
                    result[key] = true;
                    return result;
                }, {});

                const numberFormat = _.pick(attrs, ['grouping', 'separator']);

                // disable changing the value by scrolling
                disableScrollValueChange();

                // disallow possibility of entering 'e', +, -
                if (inputOptions.noSpecialChar) {
                    disallowSpecialChars();
                }

                ngModelCtrl.$parsers.unshift(function(viewVal) {
                    if ((inputOptions.integer && viewVal !== null) && (
                            (numberFormat.grouping && viewVal.indexOf(numberFormat.grouping) !== -1)
                            || viewVal.indexOf(numberFormat.separator) !== -1
                        )) {
                        ngModelCtrl.$setValidity('inputNumber', false);
                        element.parent().addClass('has-error');
                        return viewVal;
                    }

                    if (inputOptions.positiveInteger && parseInt(viewVal) < 0) {
                        ngModelCtrl.$setValidity('inputNumber', false);
                        return viewVal;
                    }

                    if (inputOptions.positiveInteger && _.isNaN(Number(viewVal))) {
                        ngModelCtrl.$setValidity('inputNumber', false);
                        return viewVal;
                    }

                    const usedGroupSep = (numberFormat.grouping && viewVal.indexOf(numberFormat.grouping) !== -1)
                        ? numberFormat.grouping : '';

                    let pattern = '[0-9]{1,3}'
                        + '(' + usedGroupSep.replace('.', '\\.') + '[0-9]{3})*'
                        + '(' + numberFormat.separator.replace('.', '\\.') + '[0-9]+)?'
                        + '$';

                    if (!inputOptions.positiveInteger) {
                        pattern = '^-?' + pattern;
                    }

                    if (inputOptions.allowEmpty) {
                        pattern = '(' + pattern + '|^$)';
                    }

                    if (!viewVal.match(new RegExp(pattern)) || (inputOptions.positiveInteger && viewVal < 1)) {
                        ngModelCtrl.$setValidity('inputNumber', false);
                        element.parent().addClass('has-error');
                        return viewVal;
                    }

                    if (attrs.max && parseFloat(viewVal) > parseFloat(attrs.max)) {
                        ngModelCtrl.$setValidity('maxNumber', false);
                        element.parent().addClass('has-error');
                        return viewVal;
                    }

                    if (attrs.min && parseFloat(viewVal) < parseFloat(attrs.min)) {
                        ngModelCtrl.$setValidity('minNumber', false);
                        element.parent().addClass('has-error');
                        return viewVal;
                    }

                    ngModelCtrl.$setValidity('maxNumber', true);
                    ngModelCtrl.$setValidity('minNumber', true);

                    ngModelCtrl.$setValidity('inputNumber', true);
                    element.parent().removeClass('has-error');

                    // first remove the group separator
                    // second replace the decimal separator
                    const replacePattern = new RegExp(numberFormat.grouping.replace('.', '\\.'), 'g');
                    const modelVal = parseFloat(
                        viewVal
                            .replace(replacePattern, '')
                            .replace(numberFormat.separator, '.')
                    );

                    if (_.isNumber(modelVal) && !isNaN(modelVal)) {
                        return modelVal;
                    }
                    return viewVal;
                });

                ngModelCtrl.$formatters.unshift(function(modelVal) {
                    if (_.isEmpty(modelVal)) {
                        // set the validity based on allowEmpty setting
                        if (!inputOptions.allowEmpty) {
                            ngModelCtrl.$setValidity('inputNumber', false);
                        }
                        return '';
                    }

                    return (String(parseFloat(modelVal))).replace('.', numberFormat.separator);
                });

                /**
                 * @ngdoc
                 * @name disableScrollValueChange
                 * @description Disables change of the value with scrolling
                 */
                function disableScrollValueChange() {
                    // disable changing number by scrolling
                    element.on('focus', function() {
                        $(this).on('mousewheel.disableScroll', function(e) {
                            e.preventDefault();
                        });
                    });

                    element.on('blur', 'input[type=number]', function() {
                        $(this).off('mousewheel.disableScroll');
                    });
                }

                /**
                 * @ngdoc
                 * @name disallowSpecialChars
                 * @description Disallows special characters: e, +, -
                 */
                function disallowSpecialChars() {
                    element.bind('keypress', (event) => {
                        const code = event.which || event.keyCode;

                        if (code === 101 || code === 43 || code === 45) {
                            event.preventDefault();
                        }
                    });
                }
            }
        };
    }
})(window.angular, window.$, window._);
